import React, { useState, useEffect, useCallback } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import TaskModalWrapper from './TaskModal.styles';
import { Form, Input, Button, Select, Row, Col, DatePicker, Upload } from 'antd';
import _ from 'lodash';
import { taskPriorities } from '@iso/constants/taskPriorities';
import { taskStatus } from '@iso/constants/taskStatus';
import Loader from '@iso/components/utility/loader';
import { propertyService, taskService } from '@iso/services';
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import modalActions from '@iso/redux/modal/actions';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import { UploadOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import FileUploader from "@iso/components/FileUploader/FileUploader";
import { FileStorage } from "@iso/constants/UploadFile";
import { propertyHelper } from "@iso/lib/helpers/propertyHelper";

const { Option } = Select;
const { closeModal } = modalActions;

const TaskModal = (props) => {
  const activePermission = useSelector((state) => state.permission.activePermission);
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const activePropertySubscription = useSelector((state) => state.subscription.activePropertySubscription);
  
  const [form] = Form.useForm();
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [modalLoading, setModalLoading] = useState(true);
  const [assignees, setAssignees] = useState([]);
  const modalVisibility = useSelector((state) => state.modal.modalVisibility);
  const modalData = useSelector((state) => state.modal.modalData);
  const dispatch = useDispatch();
  const [dataTask, setDataTask] = useState({});
  const [imageId, setImageId] = useState(null);

  const updateDataAssignee = useCallback(() => {
    propertyService.getListUsersOfProperty(props.propertyId).then(res => {
      if(res.code === '0000'){
        setAssignees(res.users);
        setModalLoading(false);
      }
    });
  }, [props]);
  useEffect(() => {
    if(modalData.type === 'task'){
      if(JSON.stringify(modalData.object) !== '{}'){
         if(modalData.object){
            setDataTask(modalData.object);
          if(modalData.object.tags){
            let task_tags = modalData.object.tags.split('|');
            setTags(task_tags);
          }
        }
        setFields([
          {
            name: ['task', 'title'],
            value: modalData.object.title || '',
          },
          {
            name: ['task', 'due_date'],
            value: modalData.object.due_date ? moment(modalData.object.due_date) : '',
          },
          {
            name: ['task', 'priority'],
            value: modalData.object.priority || 'medium',
          },
          {
            name: ['task', 'status'],
            value: modalData.object.status || 'todo',
          },
          {
            name: ['task', 'assignee_id'],
            value: modalData.object.assignee ? modalData.object.assignee.id : 0,
          },
          {
            name: ['task', 'tags'],
            value: modalData.object.tags || '',
          },
          {
            name: ['task', 'details'],
            value: modalData.object.details || '',
          },
          {
            name: ['task', 'primary_object_id'],
            value: modalData.object.primary_object_id ? modalData.object.primary_object_id : 0,
          },
        ]);
      }else{
        setFields([
          {
            name: ['task', 'priority'],
            value: 'medium',
          },
          {
            name: ['task', 'status'],
            value: 'todo',
          },
          {
            name: ['task', 'assignee_id'],
            value: 0,
          },
          {
            name: ['task', 'primary_object_id'],
            value: props.dataObject ? props.dataObject.id : 0,
          },
        ]);
      } 
      if(props.propertyId && modalVisibility){
        updateDataAssignee();
      }
    }

    setImageId(null);

  }, [props.propertyId, updateDataAssignee, modalVisibility, modalData]);

  const cancelModal = () => {
    dispatch(closeModal());
    setTags([]);
    if(modalData.layer){
      modalData.featureGroup.leafletElement.removeLayer(modalData.layer);
    }
    setLoading(false);
    form.resetFields();
  }

  const renderOptionPriority = () => {
    let options = [];
    _.forEach(taskPriorities, (taskPriority, index) => {
      options.push(
        <Option key={index} value={taskPriority.value}>
          {taskPriority.label}
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionStatus = () => {
    let options = [];
    _.forEach(taskStatus, (status, index) => {
      options.push(
        <Option key={index} value={status.value}>
          {status.label}
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionAssignee = (users) => {
    let options = [];
    _.forEach(users, (user, index) => {
      options.push(
        <Option key={user.id} value={user.id}>
          {user.name} | {user.email} 
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
      >
        <Option key={0} value={0}>
          Not assigned
        </Option>
        {options}
      </Select>
    );
  }

  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
        disabled={JSON.stringify(modalData.object) !== '{}' ? false : true}
      >
        <Option key={0} value={0}>
          No paddock
        </Option>
        {options}
      </Select>
    );
  }

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then(values => {
        values.task.tags = tags;
        onStore(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
        setLoading(false);
      });
  }

  const onStore = (values) => {
    const data = {
      task:{
        ...values.task,
        due_date: values.task.due_date ? dateHelper.dateForAPI(values.task.due_date) : '',
        point: dataTask.point,
        property_id: props.propertyId,
        image_id: imageId
      }
    }

    taskService.storeOrUpdateTasks(data, dataTask.id).then(res => {
      if(res.code === '0000'){
        props.onSaved(res.task);
        cancelModal();
        form.resetFields();
        setTags([]);
      } else {
        setLoading(false);
      }
    });
  }

  const editLocation = () => {
    props.editLocation();
    cancelModal();
  }

  const handleChangeTag = (input_tags) => {
    setTags(input_tags);
  }

  useEffect(() => {
    handleChangeTag(tags)
  }, [tags]);

  const handleOnUploadSuccess = (image) => {
    setImageId(image.id);
  }

  return (
    <TaskModalWrapper
      className="user-access-modal"
      forceRender={true}
      visible={modalVisibility && modalData.type === 'task'}
      title={ dataTask.id ? <IntlMessages id="propertyMapPage.editTask" /> : <IntlMessages id="propertyMapPage.addTask" /> }
      onCancel={cancelModal}
      maskClosable={false}
      footer={[
        (activePermission == "owner" || activePermission == "admin"|| activePermission == "modify") && dataTask.id && <Button key="editLocation" onClick={editLocation} style={{float: 'left'}} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.move" />}
        </Button>,
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        (activePermission == "owner" || activePermission == "admin"|| activePermission == "modify") && <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
      {
      
        <Form
          form={form}
          name="addEditTask"
          layout="vertical"
          scrollToFirstError
          fields={fields}
        >
          <div className="form-body">
            <Form.Item
              name={['task', 'title']}
              className="isoInputWrapper"
              label="Title"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
                {
                  whitespace:true,
                  message: 'Please input your Title',
                },
              ]}
            >
              <Input size="large" placeholder="Input task title"/>
            </Form.Item>
            <Form.Item
              name={['task', 'priority']}
              label="Priority"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionPriority()}
            </Form.Item>
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['task', 'due_date']}
                  className="isoInputWrapper"
                  label="Due Date"
                >
                  <DatePicker size="large"/>
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['task', 'status']}
                  className="isoInputWrapper"
                  label="Status"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionStatus()}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{span: 24}} md={{span: dataTask.id ? 11 : 24}}>
                <Form.Item
                  name={['task', 'assignee_id']}
                  className="isoInputWrapper"
                  label="Assignee"
                >
                  {renderOptionAssignee(assignees)}
                </Form.Item>
              </Col>
              {
                dataTask.id &&
                <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                  <Form.Item
                    name={['task', 'primary_object_id']}
                    className="isoInputWrapper"
                    label="Object"
                  >
                    {renderOptionObject(props.primaryObjects)}
                  </Form.Item>
                </Col>
              }
            </Row>
            <Form.Item
              className="isoInputWrapper"
              label="Tags"
            >
              <TagsInput name={['task', 'tags']} value={tags} onChange={handleChangeTag} addOnBlur="true"/>
            </Form.Item>
            <Form.Item name={['task', 'details']} label="Details">
              <Input.TextArea />
            </Form.Item>

            {propertyHelper.checkIsGoldPackage(activePropertySubscription) && 
              <><Form.Item name={['attachment']} label="Attachment">
                <FileUploader
                  type='tasks'
                  storage={FileStorage.filesystem}
                  isCompressFile={true}
                  handleOnSuccess={handleOnUploadSuccess}
                />
              </Form.Item>
              {
                dataTask.images && dataTask.images.length > 0 && <img style={{width:"50%"}}src={dataTask.images[dataTask.images.length-1].full_path} />
              }
              </>
            }
          </div>
        </Form>
      }
    </TaskModalWrapper>
  );
}

export default TaskModal;